module.exports = __webpack_public_path__ + "img/icon-know-home.905ec964.png";